<div class="claim_body">
    <div class="top_panel">
        <h3>User Activity Log</h3>
        <span (click)="close()" class="close">
            <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="formarea overflow-auto"> 
        <div class="user_details">
            <ul>
                <li>
                    <label>First Name</label> <span>{{data?.firstName}}</span>
                </li>
                <li>
                    <label>Last Name</label> <span>{{data?.lastName}}</span>
                </li>
                <li>
                    <label>Phone Number</label> <span>{{data?.phoneNumber | mask : "(000) 000-0000"}}</span>
                </li>
                <li>
                    <label>Email Address</label> <span>{{data?.emailAddress}}</span>
                </li>
                <li>
                    <label>Sub Roles</label> <span>{{formatSubRoles(data?.userSubRoles)}}</span>
                </li>
            </ul>
        </div>
        <div class="header_container">
            
            <div class="rangeselectorprt">
                <span>
                    <div class="daterange">
                        <mat-form-field class="example-form-field" appearance="outline">
                        <mat-label>Date Range</mat-label>
                            <mat-date-range-input
                            [formGroup]="dateRangeForm"
                            [rangePicker]="campaignOnePicker"
                            [max]="today" (click)="campaignOnePicker.open()">
                            <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                            <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                            </mat-date-range-input>
                            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #campaignOnePicker>
                                <mat-date-range-picker-actions>
                                    <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                    <button class="clear" mat-button matDateRangePickerCancel *ngIf="startDate && endDate" (click)="clearDateRange()">Clear</button>
                                    <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                                </mat-date-range-picker-actions>
                            </mat-date-range-picker>
                        </mat-form-field>
                    </div>
                </span>
            </div>
        </div>
            <div class="table">
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>Created At</th>
                        <td mat-cell *matCellDef="let element">
                            {{commonService.convertDate(element?.createdAt) | date : "MMM-dd-YYYY h:mm a" }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedAt">
                        <th mat-header-cell *matHeaderCellDef>Updated At</th>
                        <td mat-cell *matCellDef="let element">
                            {{ commonService.convertDate(element?.updatedAt) | date : "MMM-dd-YYYY h:mm a" }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="claimNumber">
                        <th mat-header-cell *matHeaderCellDef>Claim Number</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="flex">
                                {{ element?.claimNumber }} 
                                <span (click)="handleViewDetails(element)" *ngIf="element?.claimNumber" style="display: flex; cursor: pointer;"><mat-icon>visibility</mat-icon></span>
                            </div>
                            
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="updatedBy">
                        <th mat-header-cell *matHeaderCellDef>Updated By</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.updatedBy?.firstName }} {{ element?.updatedBy?.lastName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedContent">
                        <th class="request_section" mat-header-cell *matHeaderCellDef>Updated Content</th>
                        <td class="content_section" mat-cell *matCellDef="let element">
                            <ng-container *ngFor="let item of objectKeys(element?.updatedContent)">
                                <span *ngIf="!array?.isArray(element?.updatedContent[item])">{{item}}: {{commonService.formatDataType(element?.updatedContent[item])}}</span>
                                <span *ngIf="array?.isArray(element?.updatedContent[item])"><span style="font-weight: 600;">{{item}}:</span>
                                  <div>
                                    <span *ngFor="let subItem of element?.updatedContent[item]">{{subItem?.question}}: {{commonService.formatDataType(subItem?.answer)}}</span>
                                  </div>
                                </span>
                            </ng-container>
                          </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columns"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns"></tr>
                </table>
                <div class="no-data" *ngIf="!dataSource?.length && !isLoading" style="padding: 10px 0; text-align: center">
                    No data found.
                </div>
            </div>
    </div>
</div>